/**
 * Created by tmorone on 2/17/2016.
 */

var Logger = require('./logger');
var $ = require('jquery');
var BootstrapDialog = require('bootstrap-dialog');
var logger = new Logger({mode: window.PR.environment})

/**
 * Stripe payment interface
 *
 * The Stripe object is added to the global object so it can be called from actionscript
 */
var Stripe = module.exports = {
    request_data: null,
    checkout_dialog: null,
    payment_open: false,
    handler: null,

    configure: function() {
        Stripe.handler = StripeCheckout.configure({
            key:         PR.stripe_public_key,
            token:       Stripe.placeOrder,
            closed:      Stripe.closeWindow,
            opened:      Stripe.openWindow,
            locale:      'auto',
            alipay:      true,
            bitcoin:     true
        });
    },

    // create safety net dialog in case the purchase window was blocked
    createDialog: function() {
        if(Stripe.payment_open)
            return;

        var ttl = "<h4 class='msg-ttl'>Complete Purchase</h4>";


        Stripe.checkout_dialog = BootstrapDialog.show({
            type: BootstrapDialog.TYPE_PRIMARY,
            title: ttl,
            closable: false,
            message: 'Complete your purchase of ' + Stripe.request_data.name,
            draggable: false,
            buttons: [
                {
                    icon: 'glyphicon glyphicon-shopping-cart',
                    label: ' Checkout',
                    cssClass: 'btn-primary center-block',
                    action: function (popup) {
                        popup.close();
                        Stripe.beginCheckout();
                    }
                }
            ]
        });

        // Align title
        Stripe.checkout_dialog.getModalHeader().css('text-align', 'center');
    },

    // entry point from the game, called with requested product data
    paymentRequest: function (data) {
        logger.info('Start payment request...');

        Stripe.request_data = JSON.parse(data);
        Stripe.checkout_dialog = null;
        Stripe.payment_open = false;

        Stripe.beginCheckout();

        setTimeout(Stripe.createDialog, 1500);
    },

    // entry point from the game, for updating player's card on file
    updateCardRequest: function (data) {
        logger.info('Updating card...');

        Stripe.request_data = JSON.parse(data);
        Stripe.checkout_dialog = null;
        Stripe.payment_open = false;

        Stripe.updateCard();

        setTimeout(Stripe.createDialog, 1500);
    },

    // show stripe checkout dialog
    beginCheckout: function () {
        logger.info('Starting checkout...');

        logger.debug('Stripe Request Data: ' + JSON.stringify(Stripe.request_data));

        var icon = 'https://s3.amazonaws.com/packrat-prod-public/images/products/ticket.png';

        // if(Stripe.request_data.subscription) {
        //     icon = 'https://s3.amazonaws.com/packrat-prod-public/images/products/XL_48.png';
        // }

        // Stripe takes price in cents
        // use exponential notation instead of * 100 to avoid precision problems
        var purchase_price = Number(Stripe.request_data.price+'e2');

        Stripe.handler.open({
            address:     false,
            zipCode:     true,
            amount:      purchase_price,
            currency:    Stripe.request_data.currency,
            name:        Stripe.request_data.name,
            description: Stripe.request_data.description,
            image:       icon,
            panelLabel:  'Checkout',
            'alipay-reusable': !!Stripe.request_data.subscription
        });
    },

    // show stripe checkout dialog for the purpose of updating the player's card on file
    updateCard: function () {
        logger.info('Updating card...');

        Stripe.handler.open({
            address:     false,
            zipCode:     true,
            name:        'Update Your Credit Card',
            panelLabel:  'Update'
        });
    },

    // called when user authorizes payment
    placeOrder: function (data) {
        logger.info('Placing order...');


        Stripe.request_data.stripe_token = data.id;
        Stripe.request_data.stripe_email = data.email;

        logger.debug('Stripe Request Data: ' + JSON.stringify(Stripe.request_data));

        if (data.card) {
            Stripe.request_data.card = data.card.last4 + '_' + data.card.exp_month + '_' + data.card.exp_year + '_' + data.card.address_zip;
        }

        logger.info('Stripe Request Data:', Stripe.request_data);

        if (Stripe.request_data.subscription) {
            Stripe.request_data.source = 'STRIPE';

            $.post('/api/purchaseSubscription' + '?user-id=' + Stripe.request_data.user_id, Stripe.request_data,
                function () {
                    logger.info('Subscription purchase success.');
                    window.gameInstance.SendMessage('Engine', 'OnStripeComplete');
                });
        } else if (Stripe.request_data.gift) {
            $.post('/api/purchaseEnd/' + Stripe.request_data.request_id + '?user-id=' + Stripe.request_data.user_id, Stripe.request_data,
                function () {
                    logger.info('Gift purchase success.');
                    window.gameInstance.SendMessage('Engine', 'OnStripeComplete');
                });
        } else if (Stripe.request_data.updateCard) {
            $.post('/api/creditCard?user-id=' + Stripe.request_data.user_id, Stripe.request_data,
                function () {
                    logger.info('Card updated.');
                });
        } else {
            $.post('/api/purchaseEnd/' + Stripe.request_data.request_id + '?user-id=' + Stripe.request_data.user_id, Stripe.request_data,
                function () {
                    logger.info('Purchase success.');
                    window.gameInstance.SendMessage('Engine', 'OnStripeComplete');
                });
        }

        Stripe.request_data = null;

        logger.info('Order complete.');
    },


    // called when user closes payment window (cancel or purchase)
    closeWindow: function () {
        window.gameInstance.SendMessage('Engine', 'OnStripeClose');
        logger.info('Closing window...');
    },

    // called when checkout window is successfully opened
    openWindow: function () {
        logger.info('Opening window...');

        Stripe.payment_open = true;

        if (Stripe.checkout_dialog) {
            Stripe.checkout_dialog.close();

            Stripe.checkout_dialog = null;
        }
    }
};

// call the configuration function to create the handler
Stripe.configure();

global.Stripe = Stripe;
